export default __webpack_public_path__ + "static/media/reliable-icon.1367510a.svg";